import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import SetupWelcomeMessage from "Signups/FamilyRegistration/Shared/SetupWelcomeMessage";

export default function AdultWelcomeMessage({ disabled }) {
  const { state } = useFamilyRegistrationContext();

  const enabled =
    state?.familyRegistrationSettings?.registrationGroupAdults?.enabled;
  const groupId =
    state?.familyRegistrationSettings?.registrationGroupAdults?.selectedGroupID;
  const shortname =
    state?.familyRegistrationSettings?.registrationGroupAdults?.availableGroups?.find(
      (group) => group.groupID === groupId
    )?.shortname;
  const registrationGroupsEnabled =
    state?.familyRegistrationSettings?.registrationGroupAdults?.enabled;

  return (
    <AnimatePresence>
      {registrationGroupsEnabled && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
        >
          <SetupWelcomeMessage
            groupName={shortname}
            disabled={disabled || !groupId || !enabled}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
